(function ($) {

	function initMasonryCollapse() {
		$('.masonry--collapsible').each(function () {
			var $gallery = $(this);
			var $toggle = $gallery.find('[data-masonry-toggle]');
			var $items = $gallery.find('.masonry-item');
			var rowsToShow = 3;

			if (!$items.length || !$toggle.length) {
				return;
			}

			function itemsPerRow() {
				var containerWidth = $gallery.width();
				var itemWidth = $items.eq(0).outerWidth(true);
				if (!itemWidth) {
					return 1;
				}
				return Math.max(1, Math.round(containerWidth / itemWidth));
			}

			function collapsedHeight() {
				var visibleCount = Math.min($items.length, itemsPerRow() * rowsToShow);
				var maxBottom = 0;

				$items.slice(0, visibleCount).each(function () {
					var bottom = $(this).position().top + $(this).outerHeight();
					if (bottom > maxBottom) {
						maxBottom = bottom;
					}
				});

				return maxBottom;
			}

			function applyCollapsed() {
				var h = collapsedHeight();
				$gallery.css('max-height', h + 'px');
			}

			function applyExpanded() {
				$gallery.css('max-height', $gallery.get(0).scrollHeight + 'px');
			}

			applyCollapsed();

			$toggle.on('click', function () {
				var expanding = !$gallery.hasClass('-expanded');
				$gallery.toggleClass('-expanded', expanding);

				if (expanding) {
					applyExpanded();
				} else {
					applyCollapsed();
				}
			});

			$(window).on('resize', function () {
				if ($gallery.hasClass('-expanded')) {
					applyExpanded();
				} else {
					applyCollapsed();
				}
			});
		});
	}

	$(document).gp_ready(function () {
		initMasonryCollapse();
	});

})(jQuery);